import { Pagination, Stack } from '@mui/material';
import React from 'react';
import useBootstrapSize from '../../../hooks/useBootstrapSize';
import CusLabelSelect from '../CusLabelSelect';
import { postOptions } from '../../../enums/enums';
import ShowContainer from '../ShowContainer';

export default function DefaultPagination({
  showSelectRecord = true,
  selectRecord,
  setSelectRecord,
  onFindClick,
  pageCount,
  curPage,
  setCurPage
}) {
  const { isMobile } = useBootstrapSize();

  return (
    <ShowContainer condition={pageCount}>
      <Stack
        justifyContent={'end'}
        direction={isMobile ? 'column' : 'row'}
        alignItems={'end'}
        gap={2}>
        <ShowContainer condition={showSelectRecord}>
          <CusLabelSelect
            isRow
            isVerySmall
            label={'Records per page'}
            value={selectRecord}
            options={postOptions}
            onChange={(val) => {
              setSelectRecord(val);
              onFindClick({ pageSize: val, pageNo: 1 });
            }}
          />
        </ShowContainer>
        <Pagination
          count={pageCount}
          page={curPage}
          color="primary"
          onChange={(_, value) => {
            const pageNo = Math.min(value, pageCount);
            setCurPage(pageNo);
            onFindClick({ pageNo });
          }}
        />
      </Stack>
    </ShowContainer>
  );
}
